<template>
	<div class="profile-box">
		<div class="profile-tags">
			<div class="profile-tags-wrap">
				<div class="profile-tag-lists">
					<div class="profile-tag" v-for="tag in tagList" @dblclick="deleteTags(tag.tag_value)">{{tag.tag_value}}</div>
					<div class="profile-tag-insert">
						<input type="text" v-model="newTagsVal" @keyup.enter="addTags" v-if="showTagInput" id="new-tags-val">
						<span @click="addTagsClick" v-else></span>
					</div>
					<div class="profile-tag-sync" title="同步标签" @click="tagSync"></div>
				</div>
			</div>
		</div>
		<div class="profile-tabs">
			<div class="profile-tab" @click="tab='basic'" :class="{'profile-tab-active':tab=='basic'?1:0}">
				<span>基本资料</span>
			</div>
			<div class="profile-tab" @click="tab='extra'" :class="{'profile-tab-active':tab=='extra'?1:0}">
				<span>扩展资料</span>
			</div>
		</div>
		<div class="profile-detail">
			<div class="profile-detail-wrap">
				<div class="profile-info-detail" v-if="tab == 'basic'">
					<ul>
						<li><label>昵称：</label><input type="text" v-model="friend.wx_name" class="profile-input" disabled="disabled"/></li>
						<li><label>微信ID：</label><input type="text" v-model="friend.open_id" class="profile-input" disabled="disabled"/></li>
						<li v-if="im_show_login_user == 1"><label>微信号：</label><input type="text" v-model="friend.alias" class="profile-input" disabled="disabled"/></li>
						<li><label>进粉时间：</label><input type="text" :value="friend.create_time" readonly="readonly" disabled="disabled" class="profile-input"/></li>
						<li>
							<label>微信备注：</label>
							<input type="text" v-model="friend.con_remark" class="profile-input"/>
							<i class="profile-basic-edit" title="修补备注" @click="reConRemark"></i>
						</li>
						<li v-if="friend.fans_type !=='C'">
							<label>类别修改：</label>
							<input type="text" v-model="friend.fans_type" class="profile-input" disabled="disabled"/>
							<i class="profile-basic-edit" title="修改为成交用户" @click="editFansType"></i>
						</li>
						<li><label>手机号：</label><input type="text" v-model="friend.mobile" class="profile-input"/></li>
						<li>
							<label>性别：</label>
							<div class="profile-radio">
								<label>男</label>
								<input type="radio" name="sex" value="1" v-model="friend.sex"/>
								<label>女</label>
								<input type="radio" name="sex" value="2" v-model="friend.sex"/>
							</div>
						</li>
						<li v-if="friend.is_intention == 0">
							<label>意向：</label>
							<div class="profile-radio">
								<label>意向粉</label>
								<input type="radio" name="sex" value="1" v-model="friend.is_intention"/>
								<label>非意向粉</label>
								<input type="radio" name="sex" value="0" v-model="friend.is_intention"/>
							</div>
						</li>
						<li>
							<label>置顶：</label>
							<div class="profile-check">
								<span :class="{'profile-check-span-active': chatting.is_top == 1}" :title="chatting.is_top == 1 ? '取消置顶' : '置顶'" @click="chatTop"></span>
							</div>
								
						</li>
						<li>
							<label>收藏：</label>
							<div class="profile-check">
								<span :class="{'profile-check-span-active': chatting.is_collect == 1}" :title="chatting.is_collect == 1 ? '取消收藏' : '收藏'" @click="chatCollect"></span>
							</div>
						</li>
						<li><button @click="save">保存当前更新</button></li>
					</ul>
				</div>
				<div class="profile-info-detail" v-else>
					<ul>
						<li v-if="department && friend.fans_consume !== undefined"><label>粉丝来源：</label><input type="text" v-model="friend.source" disabled="" class="profile-input" style="background-color: #EEEEEE;padding-left: 5px;"/></li>
						<li v-if="department && friend.fans_consume !== undefined"><label>客服层级：</label><input type="text" v-model="friend.fans_level" disabled="" class="profile-input" style="background-color: #EEEEEE;padding-left: 5px;"/></li>
						<li v-if="department && friend.fans_consume !== undefined">
							<label>消费金额：</label>
							<input type="number" v-model="friend.fans_consume" disabled="" class="profile-input" style="width: 0; flex: 1;background-color: #EEEEEE;padding-left: 5px;"/>
							<i class="profile-basic-edit profile-basic-add" title="添加消费金额" @click="addConsume"></i>
							<i class="profile-basic-edit profile-basic-consume" title="消费明细" @click="showCousume"></i>
						</li>
						<li v-if="showCs">
							<label>金额录入：</label>
							<input type="number" v-model="consume" class="profile-input" style="background-color: rgb(233 247 235);padding-left: 5px;"/>
						</li>
						<li v-if="showCs">
							<label>录入时间：</label>
							<input type="datetime-local" v-model="consumeTime" class="profile-input" style="background-color: rgb(233 247 235);padding-left: 5px;"/>
							<i class="profile-basic-edit profile-basic-submit" title="消费时间" @click="saveConsume"></i>
						</li>
						<transition name="fade">
							<li v-if="shwoCl">
								<table class="profile-basic-table">
									<tr>
										<th width="100px">消费金额</th>
										<th width="130px">消费时间</th>
										<th width="40px">操作</th>
									</tr>
									<tr v-for="(consume,key) in consumeList">
										<td>{{consume.money}}</td>
										<td>{{consume.consume_time}}</td>
										<td><span class="profile-consume-del" @click="delCousume(consume,key)"></span></td>
									</tr>
								</table>
							</li>
						</transition>
						<li v-if="friend.birthday !== undefined"><label>生日：</label><input type="text" v-model="friend.birthday" class="profile-input" placeholder="2000-01-01"/></li>
						<li v-if="friend.industry !== undefined"><label>所属行业：</label><input type="text" v-model="friend.industry" class="profile-input"/></li>
						<li v-if="friend.height !== undefined"><label>身高(cm)：</label><input type="text" v-model="friend.height" class="profile-input"/></li>
						<li v-if="friend.weight !== undefined"><label>体重(kg)：</label><input type="text" v-model="friend.weight" class="profile-input"/></li>
						<li v-if="friend.children !== undefined"><label>子女状态：</label><input type="text" v-model="friend.children" class="profile-input"/></li>
						<li v-if="friend.marry !== undefined">
							<label>婚姻：</label>
							<div class="profile-radio">
								<label>已婚</label>
								<input type="radio" name="marry" value="1" v-model="friend.marry"/>
								<label>未婚</label>
								<input type="radio" name="marry" value="0" v-model="friend.marry"/>
							</div>
						</li>
						<li v-if="friend.r_address !== undefined">
							<label>收货地址：</label>
							<div class="profile-info-li-inner">
								<div class="profile-info-li-inner-item">
									<select v-model="selectedProvince"> 
										<option :value="province.name" v-for="province in provinceList">{{province.name}}</option>
									</select>
									<select v-model="selectedCity">
										<option :value="city.name" v-for="city in cityList">{{city.name}}</option>
									</select>
									<select v-model="selectedArea">
										<option :value="area.name" v-for="area in areaList">{{area.name}}</option>
									</select>
								</div>
							</div>
						</li>
						<li v-if="friend.r_address !== undefined"><label>详细地址：</label><input type="text" v-model="friend.r_address" class="profile-input"/></li>
						<li v-if="friend.user_name !== undefined">
							<label>使用人：</label>
							<div class="cp-flex1">
								<select v-model="friend.user_name" class="cp-select">
									<option :value="val" v-for="val in use_name_list">{{val}}</option>
								</select>
								<input type="text" v-model="friend.user_name_other" class="profile-input cp-flex-margin-top10" v-if="friend.user_name_other !== undefined && friend.user_name === '其他'"/>
							</div>
						</li>
						<li v-if="friend.user_age !== undefined"><label>客户年龄：</label><input type="number" v-model="friend.user_age" class="profile-input"/></li>
						<li v-if="friend.use_over_time !== undefined"><label>用完时间：</label><input type="datetime-local" v-model="friend.use_over_time" class="profile-input"/></li>
						<li v-if="friend.use_tip_time !== undefined"><label>提醒时间：</label><input type="datetime-local" v-model="friend.use_tip_time" class="profile-input"/></li>
						<li v-if="friend.use_rate !== undefined">
							<label>使用频率：</label>
							<div class="cp-flex1">
								<select v-model="friend.use_rate" class="cp-select">
									<option :value="val" v-for="val in use_rate_list">{{val}}</option>
								</select>
								<input type="text" v-model="friend.use_rate_other" class="profile-input cp-flex-margin-top10" v-if="friend.use_rate_other !== undefined && friend.use_rate === '其他'"/>
							</div>
						</li>
						<li v-if="friend.user_crowd !== undefined">
							<label>所属人群：</label>
							<div class="cp-flex1">
								<select v-model="friend.user_crowd" class="cp-select">
									<option :value="val" v-for="val in user_crowd_list">{{val}}</option>
								</select>
								<input type="text" v-model="friend.user_crowd_other" class="profile-input cp-flex-margin-top10" v-if="friend.user_crowd_other !== undefined && friend.user_crowd === '其他'"/>
							</div>
						</li>
						<li v-if="friend.user_illness !== undefined">
							<label>所属症状：</label>
							<div class="cp-flex1">
								<select v-model="friend.user_illness" class="cp-select" multiple style="height: 104px;color: #c7c7c7;">
									<option :value="val" v-for="val in user_illness_list">{{val}}</option>
								</select>
								<input type="text" v-model="friend.user_illness_other" class="profile-input cp-flex-margin-top10" v-if="friend.user_illness_other !== undefined && friend.user_illness[0] === '其他'"/>
							</div>
						</li>
						<li><label>系统备注：</label><textarea placeholder="系统备注" v-model="friend.system_remark"></textarea></li>
						<li v-if="friend.friend_mobile_id === 0" style="font-size: 12px;"><span style="display: inline-block;padding: 2px 10px;background-color: orange;color: #FFFFFF;margin-left: 75px;border-radius: 2px;cursor: pointer;" @click="bindToCrm">未绑定到CRM客户</span></li>
						<li><button @click="save">保存当前更新</button></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getCurrentTime,getLocalConfig} from '../../../functions/Common.js'
	import {mapState} from 'vuex'
	import {webGetFansById,webSaveFansInfo,webSaveFansConsume,getFansConsumeList,delFansConsume,webSaveFansToCrm} from '../../../network/web/friend.js'
	import CitySelect from '../../../util/select.region.js'
	import {pushReConRemark,pushEditFansType,pushTagsUpdate,pushTagsDelete,pushTagsSync} from '../../../socket/socketEventSender.js'
	import {getFansTagsByCFid} from '../../../network/local/custom-friends-tags.js'
	import {updateRecentlyById} from '../../../network/local/recently.js'
	import {webUpdateRecentlyById} from '../../../network/web/recently.js'
	
	export default {
		name:'HomeInfoProfile',
		props:{
			  chatting:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			  }
		},
		data(){
			return {
				tab:'basic',
				tagList:[],
				friend:{},
				selectedProvince:'',
				selectedCity:'',
				selectedArea:'',
				provinceList:[],
				cityList:[],
				areaList:[],
				showTagInput: false,
				newTagsVal: '',
				consume: 0,
				consumeTime: '',
				showCs: false,
				consumeList:[],
				shwoCl:false,
				department: false,
				im_show_login_user: 0,
				use_rate_list:['首次','偶尔','长期','其他'],
				use_name_list:['本人','家人','亲友','自己及家人一起'],
				user_crowd_list:['运动类','老年类','日常保养类','关节及骨类疾病','其他'],
				user_illness_list:['高血压','高血脂','糖尿病','心脑血管','三高','尿酸高/痛风','其他'],
			}
		},
		methods:{
			// 根据当前聊天对象，获取服务器粉丝详情
			getFansDetail(fansId){
				if(fansId === undefined || fansId === 0){
					return
				}
				// 获取服务器端粉丝数据
				webGetFansById(fansId,data=>{
					if(data.code == 0){
						return
					}
					this.friend = data.data
					this.selectedProvince = this.friend.r_province
					this.selectedCity = this.friend.r_city
					this.selectedArea = this.friend.r_area
					this.showCs = false
					this.consume = 0
					this.shwoCl = false
					this.consumeList = []
					this.initPCAData()
				})
				
				// 获取本地标签列表
				getFansTagsByCFid(this.fans.custom_id,this.fans.fans_id,tags=>{
					this.tagList = tags
				})
			},
			
			// 初始化省市区信息
			initPCAData(){
				this.provinceList = CitySelect.provinceList()
				this.selectCity(true)
				this.selectArea(true)
			},
			
			// 监听省变化
			selectCity(init){
				this.cityList = CitySelect.getCityList(this.selectedProvince)
				if(init === undefined){
					if(this.cityList[0] !== undefined){
						// this.selectedCity = this.cityList[0].name
					}
				}
			},
			
			// 监听城市变化
			selectArea(init){
				this.areaList = CitySelect.getAreaList(this.selectedProvince,this.selectedCity)
				if(init === undefined){
					if(this.areaList[0] !== undefined){
						// this.selectedArea = this.areaList[0].name
					}
				}
			},
			
			// 保存数据
			save(){
				this.friend.r_province = this.selectedProvince
				this.friend.r_city = this.selectedCity
				this.friend.r_area = this.selectedArea
				webSaveFansInfo(this.friend,res=>{
					if(res.code == 1){
						CHAT_LAYER.msg(res.msg,{icon:1})
					}else{
						CHAT_LAYER.msg(res.msg,{icon:2})
					}
				})
			},
			
			// 推送修改备注的socket
			reConRemark(){
				CHAT_LAYER.msg('指令推送成功，请稍后',{icon:7})
				pushReConRemark(this.friend.con_remark,this.fans.phone_id,this.fans.fans_wx_id)
			},
			
			// 推送修改粉丝类型指令
			editFansType(){
				let _this = this
				CHAT_LAYER.confirm('确定修改为已成交吗？', {
					title: '提示',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					CHAT_LAYER.msg('指令推送成功，请稍后',{icon:7})
					pushEditFansType(_this.fans.custom_id,'C',_this.fans.phone_id,_this.fans.fans_wx_id)
				}, function(index2){
					//按钮【按钮二】的回调
				});
			},
			
			// 重新渲染备注
			reoladRemark(nVal){
				if(this.fans.fans_id == nVal.friend_id){
					this.friend.con_remark = nVal.con_remark
				}
			},
			
			// 重新渲染标签列表
			tagsSyncCall(nVal){
				if(nVal.tagList !== undefined && nVal.tagList.length > 0){
					this.getFansDetail(this.fans.fans_id)
				}
			},
			
			// 添加标签点击
			addTagsClick(){
				this.showTagInput = true
				this.$nextTick(()=>{
					document.getElementById('new-tags-val').focus()
				})
			},
			
			// 添加标签-回车
			addTags(){
				if(this.newTagsVal === ''){
					CHAT_LAYER.msg('标签不能为空')
					return
				}
				CHAT_LAYER.msg('指令推送成功，请稍后',{icon:7})
				pushTagsUpdate(this.fans.custom_wx_id,this.fans.fans_id,this.fans.fans_wx_id,this.fans.phone_id,this.newTagsVal)
				this.newTagsVal = ''
				this.showTagInput = false
			},
			
			// 删除粉丝标签
			deleteTags(val){
				if(val === ''){
					CHAT_LAYER.msg('标签不能为空')
					return
				}
				CHAT_LAYER.msg('指令推送成功，请稍后',{icon:7})
				pushTagsDelete(this.fans.custom_wx_id,this.fans.fans_id,this.fans.fans_wx_id,this.fans.phone_id,val)
			},
			
			// 同步标签
			tagSync(){
				CHAT_LAYER.msg('指令推送成功，请稍后',{icon:7})
				pushTagsSync(this.fans.custom_wx_id,this.fans.fans_id,this.fans.fans_wx_id,this.fans.phone_id)
			},
			
			// 置顶/取消置顶当前聊天
			chatTop(){
				if(this.chatting.is_search !== undefined && this.chatting.is_search == 1){
					if(this.chatting.chatting_id == 0){
						CHAT_LAYER.msg('未聊天过，置顶操作失败',{icon:2})
						return
					}
					if(this.chatting.is_top == 0){
						this.chatting.is_top = 1
					}else{
						this.chatting.is_top = 0
					}
					let param = {
						id: this.chatting.chatting_id,
						is_top: this.chatting.is_top
					}
					webUpdateRecentlyById(param,u_res=>{
						updateRecentlyById(param.id,param,res=>{
							this.$emit('recently-modify-call',param)
							CHAT_LAYER.msg('修改成功，请在聊天页面查看',{icon:1})
						})
					})
				}else{
					if(this.chatting.is_top == 0){
						this.chatting.is_top = 1
					}else{
						this.chatting.is_top = 0
					}
					let param = {
						id: this.chatting.id,
						is_top: this.chatting.is_top
					}
					webUpdateRecentlyById(param,u_res=>{
						updateRecentlyById(this.chatting.id,param,res=>{
							CHAT_LAYER.msg('修改成功',{icon:1})
							this.$emit('recently-modify-call',param)
						})
					})
				}
			},
			
			// 收藏/取消收藏当前聊天
			chatCollect(){
				if(this.chatting.is_search !== undefined && this.chatting.is_search == 1){
					if(this.chatting.chatting_id == 0){
						CHAT_LAYER.msg('未聊天过，收藏操作失败',{icon:2})
						return
					}
					if(this.chatting.is_collect == 0){
						this.chatting.is_collect = 1
					}else{
						this.chatting.is_collect = 0
					}
					let param = {
						id: this.chatting.chatting_id,
						is_collect: this.chatting.is_collect
					}
					webUpdateRecentlyById(param,u_res=>{
						updateRecentlyById(param.id,param,res=>{
							this.$emit('recently-modify-call',param)
							CHAT_LAYER.msg('修改成功，请在聊天页面查看',{icon:1})
						})
					})
				}else{
					if(this.chatting.is_collect == 0){
						this.chatting.is_collect = 1
					}else{
						this.chatting.is_collect = 0
					}
					let param = {
						id: this.chatting.id,
						is_collect: this.chatting.is_collect
					}
					webUpdateRecentlyById(param,u_res=>{
						updateRecentlyById(this.chatting.id,param,res=>{
							CHAT_LAYER.msg('修改成功',{icon:1})
							this.$emit('recently-modify-call',param)
						})
					})
				}	
			},
			
			//添加当前粉丝对应的号码库的消费金额
			addConsume(){
				this.showCs = !this.showCs
			},
			
			// 粉丝消费列表展示
			showCousume(){
				let _this = this
				if(!_this.shwoCl){
					getFansConsumeList(this.friend.id,res=>{
						if(res.code == 1){
							_this.consumeList = res.data
							_this.shwoCl = true
						}
					})
				}else{
					_this.shwoCl = false
				}
			},
			
			// 保存录入的消费金额
			saveConsume(){
				if(this.consume <= 0){
					CHAT_LAYER.msg('录入金额需大于0',{icon:2})
					return
				}
				let data = {
					fansId: this.friend.id,
					consume: this.consume,
					consumeTime:this.consumeTime
				}
				let _this = this
				webSaveFansConsume(data,res=>{
					if(res.code == 1){
						let consume = parseFloat(this.consume)
						if(_this.friend.fans_consume !== null && _this.friend.fans_consume !== ''){
							consume += parseFloat(_this.friend.fans_consume)
						}
						_this.friend.fans_consume = consume
						CHAT_LAYER.msg(res.msg,{icon:1})
					}else{
						CHAT_LAYER.msg(res.msg,{icon:2})
					}
				})
				this.showCs = false
			},
			
			// 删除粉丝消费记录
			delCousume(cousume,index){
				let _this = this
				CHAT_LAYER.confirm('确定删除记录吗？', {
					title: '删除提示',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					delFansConsume(cousume.id,res=>{
						if(res.code == 1){
							_this.consumeList.splice(index,1)
							let cCousume = _this.friend.fans_consume - parseFloat(cousume.money)
							if(cCousume < 0){
								cCousume = 0
							}
							_this.friend.fans_consume = cCousume
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			},
			
			// 保存粉丝到CRM
			bindToCrm(){
				let data = {
					fansId: this.friend.id
				}
				let _this = this
				webSaveFansToCrm(data,res=>{
					if(res.code == 1){
						CHAT_LAYER.msg(res.msg,{icon:1})
					}else{
						CHAT_LAYER.msg(res.msg,{icon:2})
					}
				})
			}
		},
		computed:{
			fans(){
				return this.$store.state.chatFans
			},
			
			otherEvent(){
				return this.$store.state.otherEvent
			}
		},
		watch:{
			// 监听粉丝变化
			fans(nVal){
				this.getFansDetail(nVal.fans_id)
			},
			
			// 监听省变化
			selectedProvince(nVal,oVal){
				if(nVal === null || nVal === '' || nVal === undefined){
					return
				}
				this.selectCity()
			},
			
			// 监听市变化
			selectedCity(nVal,oVal){
				if(nVal === null || nVal === '' || nVal === undefined){
					return
				}
				this.selectArea()
			},
			
			// 监听事件
			otherEvent(nVal){
				if(nVal.type === undefined){
					return
				}
				// 修改备注
				if(nVal.type === 'reConRemark'){
					this.reoladRemark(nVal)
				}
				// 标签同步
				if(nVal.type === 'TagsSync'){
					this.tagsSyncCall(nVal)
				}
			}
		},
		mounted() {
			let auto_frieds_no_b_input = getLocalConfig('auto_frieds_no_b_input')
			let gamePlug = getLocalConfig('gamePlug')
			let im_show_login_user = getLocalConfig('im_show_login_user')
			this.getFansDetail(this.$store.state.chatFans.fans_id)
			this.consumeTime = getCurrentTime()
			// 消费模块展示判断
			let department = true
			if(gamePlug === '1'){
				department = false
			}else{
				department = getLocalConfig('department') !== 'B' ? (auto_frieds_no_b_input == 1 ? true : false) : true	
			}
			this.department = department
			// 微信昵称显示判断
			this.im_show_login_user = im_show_login_user
		}
	}
</script>

<style>
	.profile-box{
		position: relative;
		width: 300px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.profile-box .profile-tags{
		padding: 10px;
	}
	.profile-tags .profile-tags-wrap{
		min-height: 30px;
		max-height: 96px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.profile-tags-wrap .profile-tag-lists{
		height: auto;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
	}
	.profile-tag-lists .profile-tag{
		border: 1px solid rgba(43,173,55,.2);
		overflow: hidden;
		text-align: center;
		padding: 0 8px;
		border-radius: 4px;
		color: #2bad37;
		background-color: rgba(43,173,55,.1);
		margin: 4px;
		cursor: pointer;
		height: 22px;
		line-height: 22px;
	}
	.profile-tag-lists .profile-tag-insert{
		height: 22px;
		line-height: 22px;
		min-width: 40px;
		margin: 4px;
		cursor: pointer;
	}
	.profile-tag-insert input{
		box-sizing: border-box;
		border: 1px solid #CCCCCC;
		outline: none;
		width: 100%;
		height: 100%;
		border-radius: 4px;
		text-indent: 4px;
		width: 50px;
	}
	.profile-tag-insert input:focus{
		border: 1px solid #2bad37;
	}
	.profile-tag-insert span{
		display: block;
		box-sizing: border-box;
		border: 1px solid #CCCCCC;
		width: 100%;
		height: 100%;
		border-radius: 4px;
		text-align: center;
		line-height: 22px;
		background-image: url(../../../assets/img/edit2.png);
		background-size: auto 80%;
		background-repeat: no-repeat;
		background-position: center;
	}
	.profile-tag-lists .profile-tag-sync{
		height: 22px;
		width: 22px;
		margin: 4px;
		cursor: pointer;
		overflow: hidden;
		border: 1px solid #CCCCCC;
		border-radius: 4px;
		background-image: url(../../../assets/img/comp-m-reload.png);
		background-size: 16px auto;
		background-repeat: no-repeat;
		background-position: center;
	}
	.profile-box .profile-tabs{
		height: 40px;
		text-align: center;
		width: 300px;
		border-top: 1px solid #dedede;
	}
	.profile-tabs .profile-tab{
		width: 50%;
		height: 38px;
		line-height: 38px;
		float: left;
		border-bottom: 2px solid #dedede;
		cursor: pointer;
	}
	.profile-tabs .profile-tab-active{
		border-bottom: 2px solid #2bad37;
		color: #2bad37;
	}
	.profile-box .profile-detail{
		padding: 10px;
		width: 280px;
		height: auto;
		overflow: hidden;
	}
	.profile-detail .profile-detail-wrap{
		width: 280px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.profile-detail-wrap .profile-info-detail{
		height: auto;
	}
	.profile-info-detail ul li{
		display: block;
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;
	}
	.profile-info-detail ul li label{
		margin-right: 5px;
		height: 21px;
		line-height: 21px;
	}
	.profile-info-detail ul li>*{
		display: block;
	}
	.profile-info-li-inner{
		width: 204px;
		height: auto;
	}
	.profile-info-li-inner .profile-info-li-inner-item{
		height: 22px;
		line-height: 22px;
		color: #888888;
	}
	.profile-info-li-inner-item select{
		width: 65px;
		border: 1px solid #dedede;
		margin: 0 1px;
		padding: 2px 0;
		color: #888888;
		border-radius: 2px;
	}
	.profile-detail-wrap textarea{
		border: 1px solid #dedede;
		height: 48px;
		width: 178px;
		resize: none;
		padding: 5px;
		border-radius: 2px;
		font-size: 12px;
		color: #888888;
	}
	.profile-detail-wrap textarea:focus{
		border: 1px solid #2bad37;
	}
	.profile-input,.profile-text{
		width: 160px;
		height: 20px;
		line-height: 20px;
		border-bottom: 1px solid #dedede;
		color: #838383;
		background-color: #ffffff;
		font-size: 13px;
	}
	.profile-input:focus{
		border-bottom: 1px solid #2bad37;
	}
	.profile-radio{
		display: inline-block;
		height: 20px;
		border-bottom: 1px solid #dedede;
	}
	.profile-radio>*{
		display: inline-block;
		vertical-align: middle;
	}
	.profile-radio input{
		margin-right: 10px;
	}
	.profile-radio label{
		margin-right: 5px;
	}
	.profile-check{
		width: 20px;
		height: 20px;
	}
	.profile-check span{
		width: 100%;
		height: 100%;
		display: inline-block;
		background-image: url(../../../assets/img/select-out.png);
		background-size: 20px auto;
		background-repeat: no-repeat;
		background-position: center;	
		cursor: pointer;
	}
	.profile-check .profile-check-span-active{
		background-image: url(../../../assets/img/select-in.png);
	}
	.profile-basic-edit{
		background-image: url(../../../assets/img/edit2.png);
		background-size: 100% 100%;
		height: 20px;
		width: 20px;
		display: inline-block;
		cursor: pointer;
	}
	.profile-basic-add{
		margin-left: 4px;
		background-image: url(../../../assets/img/add-icon-2bad37-32.png);
	}
	.profile-basic-consume{
		margin-left: 4px;
		background-image: url(../../../assets/img/chart-icon.png);
		height: 22px;
		width: 22px;
	}
	.profile-basic-submit{
		background-image: url(../../../assets/img/correct-48-active.png);
	}
	.profile-info-detail ul li button{
		border-radius: 4px;
		background-color: rgb(50, 169, 57);
		padding: 5px 15px;
		cursor: pointer;
		color: #ffffff;
	}
	.profile-basic-table{
		max-height: 200px;
		width: 100%;
		overflow: auto;
		border-collapse: collapse;
		border-spacing: 0;
		user-select: none;
	}
	.profile-basic-table th{
		background-color: #EEEEEE;
	}
	.profile-basic-table td,.profile-basic-table th{
		border: 1px solid #EEEEEE;
		padding: 5px 0;
		text-align: center;
		font-size: 13px;
	}
	.profile-consume-del{
		width: 20px;
		height: 20px;
		display: inline-block;
		background-image: url(../../../assets/img/delete-red-32.png);
		background-size: 16px auto;
		background-repeat: no-repeat;
		background-position: center;	
		cursor: pointer;
	}
	.fade-enter-active, .fade-leave-active {
	  transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	  opacity: 0;
	}
	.cp-select{
		width: 140px;
		border: 1px solid #dedede;
		padding: 2px 0;
		color: #888888;
		border-radius: 2px;
	}
	.cp-flex1{
		flex: 1;
		overflow: hidden;
	}
	.cp-flex-margin-top10{
		margin-top: 10px;
	}
</style>
